import { getNoaId } from "../../utils/session.utils";
import apiClient from "../../utils/api.client";

const getPrizes = async (page, pageSize, payload) => {
  // return fetch(`${getServiceUrl()}/prizes/search/?pageNumber=${page || 1}&pageSize=${pageSize || 20}&orderCriteria=ASC&orderField=raffleId&gameId=${payload.gameId}&gameType=${payload.gameType}${payload.serie ? `&serie=${payload.serie}` : ""}${payload.raffleNumber ? `&raffleNumber=${payload.raffleNumber}` : ""}`, {
  //   method: "GET",
  //   headers: { "Content-Type": "application/json" }
  // })
  //   .then(res => {
  //     if (res.status === 200) {
  //       return res.json()
  //     } else {
  //       throw { res, isServiceException: true }
  //     }
  //   })
  //   .catch(async (e) => {
  //     if (!e.isServiceException) {
  //       throw e
  //     } else {
  //       const res = await e.res.json();
  //       throw { ...res, isServiceException: true }
  //     }
  //   })
  try {
    const url = `/delivery-service/prizes/search/?pageNumber=${page || 1}&pageSize=${pageSize || 20}&orderCriteria=ASC&orderField=raffleId&gameId=${payload.gameId}&gameType=${payload.gameType}${payload.serie ? `&serie=${payload.serie}` : ""}${payload.raffleNumber ? `&raffleNumber=${payload.raffleNumber}` : ""}`;
    const response = await apiClient.get(url);
    const data = response.data;

    return data;
  } catch (error) {
    console.error("Error at getPrizes EP: ", error);
    throw error;
  }
};

const verifyWinnerCoupon = async (
  couponNumber,
  gameId,
  raffleNumber,
  serie,
) => {
  // return fetch(`${getServiceUrl()}/prizes/payments/verify-coupon?couponNumber=${couponNumber}&${raffleNumber ? `raffleNumber=${raffleNumber}` : `serie=${serie}`}&gameId=${gameId}`, {
  //   method: "GET",
  //   headers: { "Content-Type": "application/json" }
  // })
  //   .then(res => {
  //     if (res.status === 200) {
  //       return res.json();
  //     } else {
  //       throw { res, isServiceException: true }
  //     }
  //   })
  //   .catch(async (e) => {
  //     if (!e.isServiceException) {
  //       throw e;
  //     } else {
  //       const res = await e.res.json();
  //       throw { ...res, isServiceException: true }
  //     }
  //   })
  try {
    const organizationId = getNoaId();
    const url = `/delivery-service/prizes/payments/verify-coupon?organizationId=${organizationId}&couponNumber=${couponNumber}&${raffleNumber ? `raffleNumber=${raffleNumber}` : `serie=${serie}`}&gameId=${gameId}`;
    const response = await apiClient.get(url);
    const data = response.data;

    return data;
  } catch (error) {
    console.error("Error at verifyWinnerCoupon EP: ", error);
    throw error;
  }
};

const prizesService = {
  getPrizes,
  verifyWinnerCoupon,
};

export default prizesService;
